import { useTheme } from "@/src/styles/theme-provider";
import { ArrowRight, Star1 } from "iconsax-react-nativejs";
import { useTranslation } from "react-i18next";
import { Text, View } from "react-native";
import SnapshotAvatar from "../snapshot-avatar";

export type StarTransaction = {
  ItemId: string;
  recipientId: string;
  senderId: string;
  amount: number;
  message?: string;
  CreatedDate: string;
  senderInfo?: {
    displayName?: string;
    profileImageUrl?: string | null;
  };
  recipientInfo?: {
    displayName?: string;
    profileImageUrl?: string | null;
  };
};

type TransactionCardProps = Readonly<{
  transaction: StarTransaction;
}>;

const TransactionCard = ({ transaction }: TransactionCardProps) => {
  const { t } = useTranslation();
  const { themeVars } = useTheme();

  return (
    <View className="flex-col gap-3 p-3 md:border md:border-ash-3 rounded-xl">
      <View className="flex-row items-center justify-between">
        <View className="flex-1 flex-row items-center gap-2">
          <SnapshotAvatar user={transaction.senderInfo} size={28} />
          <Text className="text-sm font-medium text-onyx" numberOfLines={1}>
            {transaction.senderInfo?.displayName}
          </Text>
          <ArrowRight size={14} color={themeVars["--color-ash-2"] as string} />
          <Text className="text-sm font-medium text-ash-2">{t("LABEL_YOU")}</Text>
        </View>
        <View className="flex-row items-center gap-1 bg-primary-2 rounded-lg px-2 py-1">
          <Star1 size={12} color={themeVars["--color-primary-default"] as string} />
          <Text className="text-xs font-semibold text-primary">+{transaction.amount}</Text>
        </View>
      </View>

      <View className="bg-ash px-4 py-3 rounded-xl">
        <Text className="text-sm text-onyx italic" numberOfLines={2}>
          {`"${transaction.message ?? ""}"`}
        </Text>
      </View>

      <Text className="text-xs text-ash-2">
        {new Date(transaction.CreatedDate).toLocaleDateString()}
      </Text>
    </View>
  );
};

export default TransactionCard;
